import { Img, Box, Text } from 'vvs-uikit'
import { AutoRow } from 'components/Layout/Row'
import { useTranslation } from 'contexts/Localization'
import { ExpTable, ExpTHead, ExpTr } from 'views/VvsGotchi/components/QuestDetailInfo/styles'

import { QuestDetailInfoProps } from 'views/VvsGotchi/components/QuestDetailInfo/types'

import { SCORE_EXP_TIME, MOLE_DASH_MAX_EXP } from '../config'

const MoleDashQuestDetailInfo: React.FC<QuestDetailInfoProps> = () => {
  const { t } = useTranslation()

  return (
    <>
      <Box mb="32px">
        <AutoRow mb="12px">
          <Img src="/images/vvsGotchi/star.png" width="17.25px" mr="3px" />
          <Text color="black">{t('Max %maxExp% EXP per day', { maxExp: MOLE_DASH_MAX_EXP })}</Text>
        </AutoRow>
        <AutoRow mb="12px">
          <Img src="/images/vvsGotchi/flag.png" width="17px" mr="3px" />
          <Text color="black">{t('Unlimited tries per day')}</Text>
        </AutoRow>
      </Box>

      <Text color="black" fontWeight="600" mb="8px">
        {t('Dash longer for higher EXP')}
      </Text>
      <Text color="darkGrey" mb={2}>
        {t(
          'You will guide a Miner Mole across a side-scrolling landscape, avoiding obstacles to achieve a higher score.',
        )}
      </Text>
      <Text fontSize="13px" color="darkGrey">
        {t('The full EXP amount will be reset daily at 00:00 UTC.')}
      </Text>
      <Text fontSize="13px" color="darkGrey">
        {t("EXP earned from this quest will not be impacted by your team's health meter.")}
      </Text>

      <ExpTable>
        <ExpTHead>
          <tr>
            <th>
              <Text color="darkGrey" fontSize="13px">
                {t('How long you play in one go')}
              </Text>
            </th>
            <td>
              <Text color="darkGrey" fontSize="13px">
                {t('EXP')}
              </Text>
            </td>
          </tr>
        </ExpTHead>
        <tbody>
          {SCORE_EXP_TIME.map(({ time, exp }) => (
            <ExpTr key={time}>
              <td>
                <Text color="darkGrey" bold>
                  {t('Last %sec% seconds', { sec: Math.floor(time / 1000) })}
                </Text>
              </td>
              <td>
                <Img src="/images/vvsGotchi/star.png" height="17.25px" />
                <Text ml="6px" color="darkGrey" display="inline-block" bold>
                  +{exp}
                </Text>
              </td>
            </ExpTr>
          ))}
        </tbody>
      </ExpTable>

      <Text color="darkGrey" mt={3}>
        {t('EXP earned varies according to how long you last in each round of game.')}
      </Text>
    </>
  )
}

export default MoleDashQuestDetailInfo
